<template>
    <div id="exchangeVideoVip">
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">兑换视频会员页</div>
            <div class="rule" @click="inExchangeVideoVipByLaws">细则</div>
        </div>
        <!-- banner -->
        <div class="banners">
            <img src="../assets/images/img_16.png" alt="" class="bigImg">
            <!-- <img src="../assets/images/img_75.png" alt="" class="weeklyCard"> -->
        </div>
        <div class="videoBaner firstVideoMargin" @click="inChoiceVipCard">
            该视频平台热播剧banner
        </div>
        <!-- <div class="videoBaner otherVideoMargin" @click="inChoiceVipCard">
            该视频平台热播剧banner
        </div>
        <div class="videoBaner otherVideoMargin" @click="inChoiceVipCard">
            该视频平台热播剧banner
        </div>
        <div class="boxPadding">
            <div class="videoBaner" @click="inChoiceVipCard">
                该视频平台热播剧banner
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        components:{
            
        },
        data() {
            return {
                
            }
        },
        methods: {
            returnPage:function(){
                this.$router.go(-1);
            },
            // 进入 选择vip卡页
            inChoiceVipCard:function(){
                this.$router.push('/exchangeVideoVip/choiceVipCard');
            },
            // 进入 兑换视频会员细则
            inExchangeVideoVipByLaws:function(){
                this.$router.push('/exchangeVideoVip/exchangeVideoVipByLaws');
            }
        },
    }
</script>

<style lang="less" scoped>
    #exchangeVideoVip{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            .rule{
                font-size:15px;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 25px;
            }
        }
        // banner
        .banners{
            width:375px;
            height:75px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            padding-top: 15px;
            position: relative;
            .bigImg{
                width: 359px;
                height: 164px;
                margin: 0 8px;
                pointer-events:none;
            }
            .weeklyCard{
                width: 43px;
                height: 17px;
                position: absolute;
                left: 34px;
                top: 23px;
                pointer-events:none;
            }
        }

        // 该视频平台热播剧banner
        .firstVideoMargin{
            margin: 90px 15px 15px;
        }
        .otherVideoMargin{
            margin: 0 15px 15px;
        }
        .boxPadding{
            padding: 0 15px 15px;
        }
        .videoBaner{
            width:345px;
            height:100px;
            background:linear-gradient(26deg,rgba(98,107,106,1) 0%,rgba(215,222,229,1) 100%);
            border-radius:5px;
            font-size:25px;
            font-family:Arial, Helvetica, sans-serif;
            color:rgba(255,255,255,1);
            text-align: center;
            line-height:100px;
            text-shadow:0px 1px 1px rgba(0,0,0,0.1);
            font-weight: bold;
            box-shadow: 0 5px 10px rgba(0,0,0,0.1);
        }
    }
</style>